import api, { MovieAlbumRequest } from '@/api/fyApi';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_CHANNELS_ARTIST, LOAD_SEO, LOAD_CHANNELS_ROOT, SEO } from '../protocols';
export interface State {
    speaker?: MovieSpeaker,
    albums: MovieAlbum[],
    page: number,
    pageSize: number,
    total: number,
}

class MovieAuthor extends BaseModule<State> {
    constructor() {
        super(LOAD_CHANNELS_ARTIST[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                albums: [],
                page: 0,
                pageSize: 24,
                total: 0,
            },
            mutations: {
                updateSpeaker(state, data) {
                    state.speaker = data;
                },
                updateAlbums(state, result: PageResult<MovieAlbum>) {
                    state.albums = result.data;
                    state.page = result.current_page;
                    state.total = result.total;
                }
            },
            actions: {
                async loadAuthor({ commit }, { params }: Route) {
                    let speaker = await api.getMovieAuthor(params.id)
                    commit('updateSpeaker', speaker)
                    api.postHit('speaker', params.id)
                    const seoTitle = speaker.name + '-讲员-频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                },
                async loadAlbums({ commit, state }, { params }: Route) {
                    let page = parseInt(params.page) || 0
                    let request: MovieAlbumRequest = {
                        speaker_id: params.id,
                        offset: page * (state.pageSize || 24),
                        limit: 32
                    }
                    let result = await api.getMovieAlbums(request)
                    result.current_page = page;
                    commit('updateAlbums', result)
                },
                [LOAD_CHANNELS_ARTIST[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '讲员-频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch(LOAD_CHANNELS_ROOT[0] + '/loadLeft', {}, { root: true }),
                        dispatch('loadAuthor', route),
                        dispatch('loadAlbums', route),
                    ])
                }
            }
        }
    }
}

export default new MovieAuthor();